import { render } from "./4DataUMK.vue?vue&type=template&id=31adc5fa"
import script from "./4DataUMK.vue?vue&type=script&lang=js"
export * from "./4DataUMK.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__